// @flow

export const confirmChargeWithNewPaymentMethod = async (
  initialData: {},
  charge: { attributes: { paymentMethodType: string } },
  stripe: any,
  bankAttributes: ?{},
  callback: (data: any) => any,
) => {
  const {
    attributes: { paymentMethodType },
  } = charge;
  const isStripeTokenPaymentMethod =
    (paymentMethodType === 'creditCard' || !paymentMethodType) && stripe;
  let data = { ...initialData };

  if (isStripeTokenPaymentMethod) {
    data = {
      ...data,
      ...(await stripe.createToken()),
    };
  }

  if (bankAttributes) {
    data = {
      ...data,
      ...bankAttributes,
    };
  }

  callback(data);
};

export const needsToSetACreditCard = (
  paymentMethod: { attributes: { paymentMethodType: string } },
  paymentMethodToUse: string,
) => {
  const doesNotHaveCreditCardMethod =
    !paymentMethod || paymentMethod.attributes.paymentMethodType !== 'creditCard';

  return paymentMethodToUse === 'creditCard' && doesNotHaveCreditCardMethod;
};



// WEBPACK FOOTER //
// ./src/screens/payer/helpers.js